import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';

import { transactionDetails as TEXT } from 'locales/en/transaction';
import ListItem from './ListItem';

const ActivityDetails = forwardRef(
  ({ data, activeItemId, onItemClick }, ref) => {
    return (
      <>
        <h2
          className="text-javelin-gray-dark lg:text-xl text-base font-bold mb-5"
          ref={ref}
        >
          {TEXT.eventAndLogs.header}
        </h2>
        <div className="flex flex-col lg:flex-row card p-0 mb-8">
          <div
            className={`lg:border-r lg:border-b-0 border-b border-gray-200 flex-1 grid p-6 lg:p-12 lg:place-self-start gap-y-4 ${data.length > 3 ? 'overflow-y-hidden' : ''
              }`}
          >
            <p className="text-javelin-gray-light text-xs">All activity</p>
            <div
              className={'overflow-y-auto overflow-x-visible'}
            >
              <ul className="list-disc text-javelin-gray-light ml-5">
                {data.map((item, idx) => (
                  <ListItem
                    key={item.id}
                    activeItemId={activeItemId}
                    idx={idx === data.length - 1 ? 'last' : idx}
                    event={item}
                    onClick={onItemClick}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
);

ActivityDetails.propTypes = {
  data: PropTypes.array,
  activeItemId: PropTypes.any,
  onItemClick: PropTypes.func
};
ActivityDetails.defaultProps = {
  data: [],
  onItemClick: () => ({})
};

const areEqual = (prevProps, nextProps) => {
  return _isEqual(prevProps, nextProps);
};

export default memo(ActivityDetails, areEqual);
